import Link from '@Components/common/Link';
import styled from 'styled-components';
import { mq } from 'stylesheets/utils';
export const Card = styled(Link)`
  padding: 20px 14px;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  max-width: 273px;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.filterCardBg};
  margin-bottom: 24px;
  ${mq(992)} {
    display: none;
  }
`;

export const Express = styled.p`
  font-weight: ${({ theme }) => theme.fontWeight.font600};
  color: ${({ theme }) => theme.colors.blue};
  font-size: ${({ theme }) => theme.fontsizes.body16};
  text-transform: uppercase;
  line-height: 1;
  margin-bottom: 14px;
`;

export const P = styled.p`
  font-weight: ${({ theme }) => theme.fontWeight.font400};
  color: ${({ theme }) => theme.colors.gray};
  font-size: ${({ theme }) => theme.fontsizes.body16};
  text-align: center;
  max-width: 210px;
  height: calc(16px * 1.5 * 2);
  overflow: hidden;
`;
